module.exports = __webpack_public_path__ + "img/Weilin Vision Software-USB Inspection.7fc204d2.jpg";